import React from "react";
import { NavLink } from "react-router-dom";

const AboutCta = () => {
  return (
    <section className="relative w-full overflow-hidden bg-[color:var(--navy)]">
      <div className="absolute inset-0">
        <div className="absolute -top-40 -right-40 h-[34rem] w-[34rem] rounded-full bg-[color:var(--brand-accent)]/22 blur-3xl" />
        <div className="absolute -bottom-52 -left-52 h-[38rem] w-[38rem] rounded-full bg-[color:var(--brand)]/26 blur-3xl" />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/25 to-black/45" />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-20">
        <div className="mx-auto max-w-4xl text-center">
          <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-white">
            Let’s build a quality system your team can run
          </h2>
          <p className="mt-5 text-base sm:text-lg text-white/85">
            Start with a short conversation. We’ll recommend a clear path forward.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <NavLink
              to="/contact"
              className="inline-flex items-center justify-center rounded-lg px-8 py-4 text-sm font-semibold bg-[color:var(--brand-accent)] text-[color:var(--navy)] hover:brightness-95 transition shadow-lg"
            >
              Talk to Our Team
            </NavLink>

            <NavLink
              to="/services"
              className="inline-flex items-center justify-center rounded-lg px-8 py-4 text-sm font-semibold bg-white/15 text-white hover:bg-white/25 transition"
            >
              View Services
            </NavLink>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutCta;
